//Home Constants
export const HOME_URL = 'api/home'
export const GET_METHODOLOGY_PDF = '/get_methodology_pdf'